interface ConfigInstance {
  value: string | null;
  setValue: (newValue: string | null) => void;
  getValue: () => string | null;
}


const configInstance: ConfigInstance = {
     value: null, // Nuevo valor a almacenar
     setValue: function(newValue:string|null) {
      this.value = newValue;
    },
    getValue: function() {
      return this.value;
    }
  };
  
export const SingletonConfig = configInstance;